import React from 'react';
import { CircularProgress, ListItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getSecondaryColors } from '@style/styleMaterialUIGlobal';

interface LoadingProps {
  size?: number;
  hexColor?: string;
}

export default function LoadingComponent({ hexColor, size }: LoadingProps) {
  const theme = useTheme();
  const secondaryColors = getSecondaryColors(theme);
  return (
    <ListItem className="d-block text-center p-3">
      <CircularProgress size={size} style={{ color: hexColor || secondaryColors.contrastText }} />
    </ListItem>
  );
}
